var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-row" }, [
    _c("div", { staticClass: "form-group col-12" }, [
      _c("p", { staticClass: "font-weight-bold" }, [
        _vm._v("Select Character")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "models-wrapper" },
        _vm._l(_vm.fbxModels, function(model, key) {
          return _c(
            "div",
            {
              key: key,
              staticClass: "model-item",
              class: { active: _vm.activeModel === model.title },
              on: {
                click: function($event) {
                  return _vm.changeSelectedModel(key, model)
                }
              }
            },
            [
              _c("img", {
                staticClass: "img-fluid",
                attrs: { src: model.image.imageURL }
              }),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(model.name))])
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76ecca1a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76ecca1a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/timeline-components/character.vue
// module id = null
// module chunks = 